/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorizedApp
 */
export interface AuthorizedApp {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    grantorUserId: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    grantCreatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedApp
     */
    grantUpdatedAt: string;
}

/**
 * Check if a given object implements the AuthorizedApp interface.
 */
export function instanceOfAuthorizedApp(value: object): value is AuthorizedApp {
    let isInstance = true;
    isInstance = isInstance && "address" in value && value["address"] !== undefined;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;
    isInstance = isInstance && "grantorUserId" in value && value["grantorUserId"] !== undefined;
    isInstance = isInstance && "grantCreatedAt" in value && value["grantCreatedAt"] !== undefined;
    isInstance = isInstance && "grantUpdatedAt" in value && value["grantUpdatedAt"] !== undefined;

    return isInstance;
}

export function AuthorizedAppFromJSON(json: any): AuthorizedApp {
    return AuthorizedAppFromJSONTyped(json, false);
}

export function AuthorizedAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizedApp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
        'grantorUserId': json['grantor_user_id'],
        'grantCreatedAt': json['grant_created_at'],
        'grantUpdatedAt': json['grant_updated_at'],
    };
}

export function AuthorizedAppToJSON(value?: AuthorizedApp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'name': value.name,
        'description': value.description,
        'image_url': value.imageUrl,
        'grantor_user_id': value.grantorUserId,
        'grant_created_at': value.grantCreatedAt,
        'grant_updated_at': value.grantUpdatedAt,
    };
}

